var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Observable } from "./Observable";
import { EventDispatcher } from "./event/EventDispatcher";
/**
 * Proxy Handler
 */
export class ProxyHandler extends Observable {
    /**
     * Constructor
     * @protected
     */
    constructor(target) {
        super();
        this.readonlyProperties = new Map();
        this.disabledProperties = new Map();
        this.eventDispatcher = new EventDispatcher();
        this.eventEnabled = true;
        this.target = target;
    }
    /**
     * Checks available state
     */
    isAvailable() {
        return true;
    }
    /**
     * Sets parent
     * @param parent parent
     */
    setParent(parent) {
        this.parent = parent;
        this.addObserver(parent);
        parent.addObserver(this);
        this.eventDispatcher.setParent(parent.eventDispatcher);
    }
    /**
     * Gets parent
     */
    getParent() {
        return this.parent;
    }
    /**
     * Sets target
     * @param target
     */
    setTarget(target) {
        this.target = target;
    }
    /**
     * Gets target
     */
    getTarget() {
        return this.target;
    }
    /**
     * Sets readonly all
     * @param readonly readonly all
     */
    setReadonlyAll(readonly) {
        this.readonlyAll = readonly;
        this.readonlyProperties.forEach((value, key) => {
            this.readonlyProperties.set(key, readonly);
        });
        this.notifyObservers();
    }
    /**
     * Returns readonly all
     */
    isReadonlyAll() {
        let readonlyAll = false;
        if (this.parent) {
            readonlyAll = (this.parent.isReadonlyAll() === true);
        }
        if (this.readonlyAll === true) {
            readonlyAll = true;
        }
        if (this.readonlyAll === false) {
            readonlyAll = false;
        }
        return readonlyAll;
    }
    /**
     * Sets readonly
     * @param property property
     * @param readonly readonly or not
     */
    setReadonly(property, readonly) {
        this.readonlyProperties.set(property, readonly);
        this.notifyObservers();
    }
    /**
     * Returns whether property is readonly
     * @param property property
     */
    isReadonly(property) {
        let readonly = false;
        readonly = (this.isReadonlyAll() === true);
        if (this.readonlyProperties.has(property)) {
            readonly = (this.readonlyProperties.get(property) === true);
        }
        // returns
        return readonly;
    }
    /**
     * Sets disabled all
     * @param disabledAll
     */
    setDisabledAll(disabledAll) {
        this.disabledAll = disabledAll;
        this.disabledProperties.forEach((value, key) => {
            this.disabledProperties.set(key, disabledAll);
        });
        this.notifyObservers();
    }
    /**
     * Returns disabled all
     */
    isDisabledAll() {
        let disabledAll = false;
        if (this.parent) {
            disabledAll = (this.parent.isDisabledAll() === true);
        }
        if (this.disabledAll === true) {
            disabledAll = true;
        }
        if (this.disabledAll === false) {
            disabledAll = false;
        }
        return disabledAll;
    }
    /**
     * Sets disabled
     * @param property property
     * @param disabled
     */
    setDisabled(property, disabled) {
        this.disabledProperties.set(property, disabled);
        this.notifyObservers();
    }
    /**
     * Returns whether property is disabled
     * @param property
     */
    isDisabled(property) {
        let disabled = false;
        disabled = (this.isDisabledAll() === true);
        // check property is disabled
        if (this.disabledProperties.has(property)) {
            disabled = (this.disabledProperties.get(property) === true);
        }
        // returns
        return disabled;
    }
    /**
     * Adds event listener
     * @param eventType event type
     * @param eventListener event listener
     */
    addEventListener(eventType, eventListener) {
        this.eventDispatcher.addEventListener(eventType, eventListener);
    }
    /**
     * Removes event listener
     * @param eventType event type
     * @param eventListener event listener
     */
    removeEventListener(eventType, eventListener) {
        this.eventDispatcher.removeEventListener(eventType, eventListener);
    }
    /**
     * Clears event listeners
     * @param eventType event type
     */
    clearEventListeners(eventType) {
        this.eventDispatcher.clearEventListeners(eventType);
    }
    /**
     * Suspends event
     */
    suspendEvent() {
        this.eventEnabled = false;
    }
    /**
     * Resumes event listener
     */
    resumeEvent() {
        this.eventEnabled = true;
    }
    /**
     * Calls event listeners
     * @param event
     */
    dispatchEventListeners(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.eventEnabled) {
                return null;
            }
            return this.eventDispatcher.dispatchEventListeners(event).then(results => {
                if (results != null && results.length > 0) {
                    return !results.some(result => result === false);
                }
                else {
                    return null;
                }
            });
        });
    }
}
//# sourceMappingURL=ProxyHandler.js.map